'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import JGApi from '../../../general/js/jg-api';
import template from '../html/jg-leaderboard.hbs';
import templateEmpty from '../html/jg-leaderboard-empty.hbs';

const TYPE_EVENT = 1;
const TYPE_CHARITY = 2;

export default class JgLeaderboard extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.eventId = null;
        this.charityId = null;
        this.type = null;
        this.init();
    }

    init() {
        this.pageSize = this.$container.data('page-size') || 5;

        let eventId = this.$container.data('event-id');
        if (eventId) {
            this.eventId = eventId;
            this.type = TYPE_EVENT;
        } else {
            let charityId = this.$container.data('charity-id');
            if (charityId) {
                this.charityId = charityId;
                this.type = TYPE_CHARITY;
            }
        }

        if (!this.type) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        this.$container.addClass('is-loading');
        this.getLeadersData().then((response) => {
            this.renderLeaders(this.getPreparedData(response));
        }, (error) => {
            this.renderError(error);
        }).then(() => {
            this.$container.removeClass('is-loading');
        });
    }

    renderLeaders(data) {
        if (data.leaders.length > 0) {
            data.count = data.leaders.length;
            let content = template(data);
            this.$container.html(content);
        } else {
            this.renderEmpty();
        }
    }

    renderEmpty() {
        this.$container.html(templateEmpty({}));
    }

    renderError(error) {
        console.log(error);
        this.$container.html(JGApi.getDefaultErrorMessage());
    }

    getLeadersData() {
        switch (this.type) {
            case TYPE_EVENT:
                return JGApi.getInstance().getEventLeaderboard(this.eventId);
                break;
            case TYPE_CHARITY:
                return JGApi.getInstance().getCharityLeaderboard(this.charityId);
                break;
            default:
                throw new Error('Unknown leaderboard type')
        }
    }

    getPreparedEventData(response) {
        let result = {
            name: response.eventName,
            currencySign: JGApi.getCurrencySymbolByCode(response.currency),
        };

        result.leaders = response.pages.slice(0, this.pageSize).map((item, index) => {
            return this.getLeaderDataByPage(item, index);
        });

        return result;
    }

    getPreparedCharityData(response) {
        let result = {
            name: response.name,
            currencySign: JGApi.getCurrencySymbolByCode(response.currency),
        };

        result.leaders = response.pages.slice(0, this.pageSize).map((item, index) => {
            return this.getLeaderDataByPage(item, index);
        });

        return result;
    }

    getLeaderDataByPage(page, index) {
        let amount = Math.floor(page.amount);
        let targetRate = Math.floor(page.amount / page.targetAmount * 100);
        return {
            name: page.owner || 'Anonymous',
            amount: amount,
            pageTitle: page.pageTitle,
            targetRate: targetRate,
            donateUrl: JGApi.getPageDonateUrl(page.pageShortName),
            number: index + 1
        }
    }

    getPreparedData(response) {
        switch (this.type) {
            case TYPE_EVENT:
                return this.getPreparedEventData(response);
                break;
            case TYPE_CHARITY:
                return this.getPreparedCharityData(response);
                break;
            default:
                throw new Error('Unknown leaderboard type')
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/jg-leaderboard/js/generic.jg-leaderboard.js